import { ifElse, pipe } from 'ramda'
import {
  setAction,
  setLabel,
  setReceivedLabel,
  returnEventFunction,
} from '@creditas-lab/analytics-events'
import { configure } from '@creditas/event-track'
import { dispatchFrontendLoginEvent } from './commons'
import { isEmail } from '~validators/email'
import { validateCPF } from '~validators/cpf'

const identifyUsername = username => {
  const events = configure({
    application: 'login-application',
    bu: 'CR',
  })

  const email = isEmail(username) && { email: username }
  const cpf = validateCPF(username) && { cpf: username }
  const cellphone = !cpf && !email && { cellphone: username }

  events.identify({
    ...email,
    ...cpf,
    ...cellphone,
  })
}

const dispatchUserDoesNotExistPasswordCpfEvent = pipe(
  setReceivedLabel,
  setAction('user_does_not_exist|password_cpf'),
  dispatchFrontendLoginEvent,
)

const dispatchUserDoesNotExistPasswordlessCellPhoneEvent = pipe(
  setReceivedLabel,
  setAction('user_does_not_exist|passwordless_sms'),
  dispatchFrontendLoginEvent,
)

const dispatchUserDoesNotExistPasswordlessEmailEvent = pipe(
  setReceivedLabel,
  setAction('user_does_not_exist|passwordless_email'),
  dispatchFrontendLoginEvent,
)

const dispatchUserExistPasswordCpfEvent = pipe(
  setLabel('password_cpf'),
  setAction('user_exist'),
  dispatchFrontendLoginEvent,
)

const dispatchUserExistPasswordlessCellPhoneEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('user_exist'),
  dispatchFrontendLoginEvent,
)

const dispatchUserExistPasswordlessEmailEvent = pipe(
  setLabel('passwordless_email'),
  setAction('user_exist'),
  dispatchFrontendLoginEvent,
)

const dispatchNewPasswordEvent = pipe(
  setLabel(location.href),
  setAction('new_password'),
  dispatchFrontendLoginEvent,
)

const dispatchRequestForgotPasswordEvent = pipe(
  setReceivedLabel,
  setAction('requested_forgot_password'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorForgotPasswordEvent = pipe(
  setAction('error_on_forgot_password'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorLoginPasswordlessEmailEvent = pipe(
  setReceivedLabel,
  setAction('error_on_login|passwordless_email'),
  dispatchFrontendLoginEvent,
)

const dispatchSuccessLoginPasswordlessEmailEvent = pipe(
  setLabel('passwordless_email'),
  setAction('successful_login'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorLoginMagicLinkEvent = pipe(
  setReceivedLabel,
  setAction('error_on_login_magic_link'),
  dispatchFrontendLoginEvent,
)

const dispatchSucessfulLoginMagicLinkEvent = pipe(
  setAction('successful_login_magic_link'),
  dispatchFrontendLoginEvent,
)

const dispatchRequestCreatePasswordEvent = pipe(
  setReceivedLabel,
  setAction('requested_create_password'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorCreatePasswordEvent = pipe(
  setReceivedLabel,
  setAction('error_on_create_password'),
  dispatchFrontendLoginEvent,
)

const dispatchClickToLoginWithCpf = pipe(
  setAction('user_click_to_login_with_cpf'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorRequestPasswordlessLoginEmailEvent = pipe(
  setReceivedLabel,
  setAction('error_on_request_login|passwordless_email'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorRequestPasswordlessLoginCellPhoneEvent = pipe(
  setReceivedLabel,
  setAction('error_on_request_login|passwordless_sms'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorLoginPasswordlessCellPhoneEvent = pipe(
  setReceivedLabel,
  setAction('error_on_login|passwordless_sms'),
  dispatchFrontendLoginEvent,
)

const dispatchErrorLoginPasswordCpfEvent = pipe(
  setReceivedLabel,
  setAction('error_on_login|password_cpf'),
  dispatchFrontendLoginEvent,
)

const dispatchSuccessLoginPasswordlessCellPhoneEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('successful_login'),
  dispatchFrontendLoginEvent,
)

const dispatchSuccessLoginPasswordCpfEvent = pipe(
  setLabel('password_cpf'),
  setAction('successful_login'),
  dispatchFrontendLoginEvent,
)

const dispatchResendAccessCodeCellPhoneEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('resend_access_code'),
  dispatchFrontendLoginEvent,
)

const dispatchResendAccessCodeEmailEvent = pipe(
  setLabel('passwordless_email'),
  setAction('resend_access_code'),
  dispatchFrontendLoginEvent,
)

const getPasswordlessLoginNotFoundErrorEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchUserDoesNotExistPasswordlessEmailEvent),
  returnEventFunction(dispatchUserDoesNotExistPasswordlessCellPhoneEvent),
)

const getRequestPasswordlessLoginErrorEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchErrorRequestPasswordlessLoginEmailEvent),
  returnEventFunction(dispatchErrorRequestPasswordlessLoginCellPhoneEvent),
)

const getSuccessfulPasswordlessLoginEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchSuccessLoginPasswordlessEmailEvent),
  returnEventFunction(dispatchSuccessLoginPasswordlessCellPhoneEvent),
)

const getPasswordlessLoginErrorEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchErrorLoginPasswordlessEmailEvent),
  returnEventFunction(dispatchErrorLoginPasswordlessCellPhoneEvent),
)

const getPasswordlessUserExistEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchUserExistPasswordlessEmailEvent),
  returnEventFunction(dispatchUserExistPasswordlessCellPhoneEvent),
)

const getResendAccessCodeEvent = ifElse(
  isEmail,
  returnEventFunction(dispatchResendAccessCodeEmailEvent),
  returnEventFunction(dispatchResendAccessCodeCellPhoneEvent),
)

export {
  dispatchClickToLoginWithCpf,
  dispatchErrorCreatePasswordEvent,
  dispatchErrorForgotPasswordEvent,
  dispatchErrorLoginMagicLinkEvent,
  dispatchErrorLoginPasswordCpfEvent,
  dispatchErrorLoginPasswordlessCellPhoneEvent,
  dispatchErrorLoginPasswordlessEmailEvent,
  dispatchErrorRequestPasswordlessLoginCellPhoneEvent,
  dispatchErrorRequestPasswordlessLoginEmailEvent,
  dispatchNewPasswordEvent,
  dispatchRequestCreatePasswordEvent,
  dispatchRequestForgotPasswordEvent,
  dispatchResendAccessCodeCellPhoneEvent,
  dispatchResendAccessCodeEmailEvent,
  dispatchSuccessLoginPasswordCpfEvent,
  dispatchSuccessLoginPasswordlessCellPhoneEvent,
  dispatchSuccessLoginPasswordlessEmailEvent,
  dispatchSucessfulLoginMagicLinkEvent,
  dispatchUserDoesNotExistPasswordCpfEvent,
  dispatchUserDoesNotExistPasswordlessCellPhoneEvent,
  dispatchUserDoesNotExistPasswordlessEmailEvent,
  dispatchUserExistPasswordCpfEvent,
  dispatchUserExistPasswordlessCellPhoneEvent,
  dispatchUserExistPasswordlessEmailEvent,
  getPasswordlessLoginErrorEvent,
  getPasswordlessLoginNotFoundErrorEvent,
  getPasswordlessUserExistEvent,
  getRequestPasswordlessLoginErrorEvent,
  getResendAccessCodeEvent,
  getSuccessfulPasswordlessLoginEvent,
  identifyUsername,
}
